
import { defineComponent, reactive, ref } from "vue";
import { login, sysUserQuery, menuQueryList } from "@/api/api";
import { setToken, setUserInfo, getMenuList, setMenuList } from "@/utils/auth";
import { useRouter } from "vue-router";
import { UserOutlined, LockOutlined } from "@ant-design/icons-vue";
import User from "@/components/svg/User.vue";
import Lock from "@/components/svg/lock.vue";

interface FormState {
  account: string;
  password: string;
}

export default defineComponent({
  components: {
    User,
    Lock,
  },
  setup() {
    const router = useRouter();
    const loading = ref(false);
    const formState = reactive<FormState>({
      account: "",
      password: "",
    });
    // 获取第一个菜单的路径
    const getFirstMenuPath = (menuList: any[]): string => {
      if (!menuList || menuList.length === 0) {
        return "/user"; // 默认路径
      }

      // 递归查找第一个有 path 的菜单
      const findFirstPath = (menus: any[]): string | null => {
        for (const menu of menus) {
          // 如果当前菜单有 path，直接返回
          if (menu.path) {
            return menu.path;
          }
          // 如果有子菜单，递归查找
          if (menu.children && menu.children.length > 0) {
            const childPath = findFirstPath(menu.children);
            if (childPath) {
              return childPath;
            }
          }
        }
        return null;
      };

      return findFirstPath(menuList) || "/user";
    };

    const onFinish = async (values: any) => {
      loading.value = true;
      try {
        const res = await login(values);
        loading.value = false;
        if (res.code === "200") {
          setToken(res.data.token);
          localStorage.setItem("USERNAME", res.data.name);

          // 登录接口返回的数据中包含 roleType，立即保存到 USER-INFO
          if (res.data.roleType !== undefined) {
            setUserInfo({ roleType: res.data.roleType });
          }

          // 过滤菜单数据（递归过滤 type=0 的目录项，但保留其子节点）
          const filterMenuByType = (menus: any[]): any[] => {
            const result: any[] = [];
            menus.forEach(menu => {
              if (menu.type === 0) {
                // type=0 目录本身不保留，但将其子节点提升到当前层级
                if (menu.children && menu.children.length > 0) {
                  result.push(...filterMenuByType(menu.children));
                }
              } else {
                const item = { ...menu };
                if (item.children && item.children.length > 0) {
                  item.children = filterMenuByType(item.children);
                }
                result.push(item);
              }
            });
            return result;
          };

          // 获取菜单数据
          try {
            const menuRes = await menuQueryList({});
            if (menuRes.code === "200" && menuRes.data) {
              // 过滤掉 type=0 的菜单项后再保存
              const filteredMenuData = filterMenuByType(menuRes.data);
              setMenuList(filteredMenuData);
            }
          } catch (error) {
            console.error("获取菜单数据失败:", error);
          }

          // 获取第一个菜单的路径（从已保存的菜单数据中获取）
          const menuList = getMenuList();
          let firstMenuPath = "/user"; // 默认路径
          
          if (menuList && Array.isArray(menuList) && menuList.length > 0) {
            firstMenuPath = getFirstMenuPath(menuList);
          }

          // 调用 sysUserQuery 获取用户详细信息并保存到缓存
          // 合并 roleType 到用户信息中，确保 roleType 不会丢失
          sysUserQuery({}).then((userRes) => {
            if (userRes.code === "200" && userRes.data) {
              // 合并登录接口返回的 roleType 到用户详细信息中
              const userInfo = {
                ...userRes.data,
                roleType: res.data.roleType !== undefined ? res.data.roleType : userRes.data.roleType
              };
              setUserInfo(userInfo);
            }
          });

          // 跳转到第一个菜单
          router.push(firstMenuPath);
        }
      } catch (error) {
        loading.value = false;
        console.error("登录失败:", error);
      }
    };

    const onFinishFailed = (errorInfo: any) => {
      console.log("Failed:", errorInfo);
    };
    return {
      formState,
      loading,
      onFinish,
      onFinishFailed,
    };
  },
});
